<template>
  <div class="sp-api-page">
    <section class="hero">
      <div class="container hero-grid">
        <div class="hero-copy">
          <p class="eyebrow">BAILYHANGA / Amazon Selling Partner API</p>
          <h1>{{ texts.title }}</h1>
          <p class="lead">{{ texts.lead }}</p>
        </div>
        <aside class="document-meta" aria-label="Document status">
          <div><span>DOCUMENT</span><strong>SP-API / 01</strong></div>
          <div><span>STATUS</span><strong class="active-status">ACTIVE</strong></div>
          <div><span>VERSION</span><strong>2026.08</strong></div>
          <div><span>SCOPE</span><strong>PUBLIC</strong></div>
        </aside>
      </div>
    </section>

    <section class="content">
      <div class="container document-layout">
        <aside class="document-index">
          <p class="index-label">Contents</p>
          <a href="#audience"><span>01</span>{{ sectionName(texts.audienceTitle) }}</a>
          <a href="#functions"><span>02</span>{{ sectionName(texts.featureTitle) }}</a>
          <a href="#boundaries"><span>03</span>{{ sectionName(texts.boundaryTitle) }}</a>
          <a href="#permissions"><span>04</span>{{ sectionName(texts.permissionTitle) }}</a>
          <a href="#security"><span>05</span>{{ sectionName(texts.securityTitle) }}</a>
        </aside>

        <article class="document-body">
          <section id="audience" class="document-section">
            <span class="section-number">01</span>
            <div><h2>{{ sectionName(texts.audienceTitle) }}</h2><p>{{ texts.audienceText1 }}</p><p>{{ texts.audienceText2 }}</p></div>
          </section>

          <section id="functions" class="document-section">
            <span class="section-number">02</span>
            <div><h2>{{ sectionName(texts.featureTitle) }}</h2><ul class="numbered-list"><li v-for="(item, index) in texts.featureItems" :key="item"><span>0{{ index + 1 }}</span>{{ item }}</li></ul></div>
          </section>

          <section id="boundaries" class="document-section dark-section">
            <span class="section-number">03</span>
            <div><h2>{{ sectionName(texts.boundaryTitle) }}</h2><ul class="boundary-list"><li v-for="item in texts.boundaryItems" :key="item">{{ item }}</li></ul></div>
          </section>

          <section id="permissions" class="document-section">
            <span class="section-number">04</span>
            <div><h2>{{ sectionName(texts.permissionTitle) }}</h2><p>{{ texts.permissionText1 }}</p><p>{{ texts.permissionText2 }}</p></div>
          </section>

          <section id="security" class="document-section">
            <span class="section-number">05</span>
            <div><h2>{{ sectionName(texts.securityTitle) }}</h2><ul class="security-list"><li v-for="item in texts.securityItems" :key="item">{{ item }}</li></ul></div>
          </section>

          <section class="notice">
            <p class="notice-kicker">Official Statement</p>
            <strong>{{ texts.noticeLabel }}</strong>
            <p>{{ texts.noticeText }}</p>
          </section>

          <nav class="actions" aria-label="Related pages">
            <router-link :to="{ name: 'BrandAnalyticsDetail' }" class="action-link">{{ texts.brandLink }}<span>&rarr;</span></router-link>
            <router-link :to="{ name: 'privacyDetail' }" class="action-link">{{ texts.privacyLink }}<span>&rarr;</span></router-link>
            <a class="action-link primary" :href="contactHref">{{ texts.contactLink }}<span>&rarr;</span></a>
          </nav>
        </article>
      </div>
    </section>
  </div>
</template>

<script>
import { localeState } from "@/utils/locale";

export default {
  name: "SpApiCompliance",
  data() {
    return {
      copy: {
        zh: {
          title: "SP-API 服务说明与合规声明",
          lead:
            "本网站用于公开说明GO GLOBAL CREDIT LIMTED为亚马逊卖家及品牌所有者提供的 SaaS 运营管理服务，以及我们对 Amazon SP-API 数据使用、权限申请和安全合规的承诺。",
          audienceTitle: "1. 服务对象与授权方式",
          audienceText1:
            "我们的系统面向亚马逊卖家、品牌所有者及其授权团队成员提供服务。只有在客户完成明确授权后，我们才会通过 Amazon SP-API 访问其店铺或品牌相关数据。",
          audienceText2:
            "所有数据访问均以客户授权为前提，客户可根据业务需要授予、调整或撤销相关权限。",
          featureTitle: "2. 应用功能说明",
          featureItems: [
            "订单与履约管理：用于同步订单、发货、物流和售后处理所需的信息。",
            "库存与供应链协同：用于库存监控、补货建议、采购和仓储流程管理。",
            "财务与经营报表：用于账单核对、利润统计、经营看板和内部决策分析。",
            "广告与运营分析：用于广告投放监控、效果分析和运营效率提升。",
            "品牌分析相关功能：仅在客户具备相应资格并明确授权后，用于展示其自有品牌的经营分析结果。",
          ],
          boundaryTitle: "3. 数据使用边界",
          boundaryItems: [
            "我们不会出售、转让、出租、许可或公开披露通过 Amazon SP-API 获取的数据。",
            "我们不会将多个卖家或多个品牌的 Amazon 数据汇总后对外提供、展示或售卖。",
            "每个客户的数据在系统内按账户隔离，仅用于该客户自身的业务管理和分析。",
            "如涉及买家个人信息，仅限于订单履约、售后服务等必要场景使用，并遵循最小化原则。",
          ],
          permissionTitle: "4. 权限申请原则",
          permissionText1:
            "我们仅申请为上述产品功能提供服务所必需的 SP-API 权限，实际申请范围以 Amazon 开发者资料中提交的角色与权限说明为准。",
          permissionText2:
            "如申请品牌分析相关角色，该能力仅服务于已授权卖家或品牌所有者的内部经营分析，不面向公众提供聚合数据产品。",
          securityTitle: "5. 数据安全与隐私保护",
          securityItems: [
            "对敏感数据传输与存储采取加密保护措施，并实施最小权限访问控制。",
            "仅授权员工可访问履行岗位职责所需的数据，并保留访问日志用于审计。",
            "客户可依据协议及隐私政策申请查看、调整或撤销相关授权。",
          ],
          noticeLabel: "合规声明：",
          noticeText:
            "GO GLOBAL CREDIT LIMTED提供的是面向授权客户的管理软件服务，而非亚马逊数据转售、公开数据分发或跨卖家数据交易服务。",
          brandLink: "查看品牌分析功能",
          privacyLink: "查看隐私政策",
          contactLink: "联系我们",
          contactSubject: "SP-API 合规咨询",
        },
        en: {
          title: "SP-API Service Overview and Compliance Statement",
          lead:
            "This page publicly explains the SaaS operational management services provided by GO GLOBAL CREDIT LIMTED for Amazon sellers and brand owners, as well as our commitments regarding Amazon SP-API data usage, permission requests, and security compliance.",
          audienceTitle: "1. Service Audience and Authorization Method",
          audienceText1:
            "Our system serves Amazon sellers, brand owners, and their authorized team members. We access store or brand-related data through Amazon SP-API only after the customer has provided explicit authorization.",
          audienceText2:
            "All data access is based on customer authorization, and customers may grant, adjust, or revoke relevant permissions according to business needs.",
          featureTitle: "2. Application Functions",
          featureItems: [
            "Order and fulfillment management: synchronize information required for orders, shipping, logistics, and after-sales processing.",
            "Inventory and supply chain collaboration: support inventory monitoring, replenishment recommendations, purchasing, and warehouse workflow management.",
            "Financial and business reporting: support bill reconciliation, profit analysis, business dashboards, and internal decision-making.",
            "Advertising and operations analysis: support campaign monitoring, performance analysis, and operational efficiency improvement.",
            "Brand analytics features: available only when the customer has the required eligibility and explicit authorization to view analytics for its own brand.",
          ],
          boundaryTitle: "3. Data Usage Boundaries",
          boundaryItems: [
            "We do not sell, transfer, rent, license, or publicly disclose data obtained through Amazon SP-API.",
            "We do not aggregate Amazon data from multiple sellers or brands for external display, delivery, or sale.",
            "Each customer's data is isolated by account in the system and is used only for that customer's own business management and analysis.",
            "If buyer personal information is involved, it is used only for necessary scenarios such as order fulfillment and after-sales service, following the principle of minimum necessary use.",
          ],
          permissionTitle: "4. Permission Request Principles",
          permissionText1:
            "We request only the SP-API permissions necessary to provide the product functions described above. The actual scope is subject to the roles and permissions submitted in our Amazon developer profile.",
          permissionText2:
            "If Brand Analytics-related roles are requested, that capability serves only the internal business analysis of authorized sellers or brand owners and is not offered as a public aggregated data product.",
          securityTitle: "5. Data Security and Privacy Protection",
          securityItems: [
            "We apply encryption measures for sensitive data in transit and at rest, together with least-privilege access controls.",
            "Only authorized employees may access data required for their job responsibilities, and access logs are retained for auditing.",
            "Customers may request to review, adjust, or revoke relevant authorizations in accordance with applicable agreements and privacy policies.",
          ],
          noticeLabel: "Compliance Statement:",
          noticeText:
            "GO GLOBAL CREDIT LIMTED provides management software services for authorized customers, not Amazon data resale, public data distribution, or cross-seller data trading services.",
          brandLink: "View Brand Analytics Features",
          privacyLink: "View Privacy Policy",
          contactLink: "Contact Us",
          contactSubject: "SP-API compliance inquiry",
        },
      },
    };
  },
  computed: {
    locale() {
      return localeState.locale;
    },
    texts() {
      return this.copy[this.locale] || this.copy.zh;
    },
    contactHref() {
      return `mailto:keith.lu@hysenglobal.com?subject=${encodeURIComponent(
        this.texts.contactSubject
      )}`;
    },
  },
  methods: {
    sectionName(value) {
      return value.replace(/^\d+\.\s*/, "");
    },
  },
};
</script>

<style scoped>
.sp-api-page {
  --ink: #122620;
  --paper: #f5f2e9;
  --accent: #d8944b;
  --line: rgba(18, 38, 32, 0.16);
  background: var(--paper);
  color: var(--ink);
  min-height: 100%;
}
.hero {
  background: #d9d3c5;
  border-bottom: 1px solid var(--line);
  padding: 5rem 0;
}
.container {
  margin: 0 auto;
  max-width: 80rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.hero-grid { display: grid; gap: 3rem; }
.hero-copy { text-align: left; }
.eyebrow {
  color: #8d592c;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  margin: 0 0 1.4rem;
  text-transform: uppercase;
}
h1 {
  color: var(--ink);
  font-family: Georgia, "Times New Roman", serif;
  font-size: 2.7rem;
  font-weight: 400;
  line-height: 1.08;
  margin: 0;
  max-width: 820px;
}
.lead {
  color: rgba(18, 38, 32, 0.66);
  font-size: 0.96rem;
  line-height: 1.85;
  margin: 1.5rem 0 0;
  max-width: 48rem;
}
.document-meta {
  border: 1px solid rgba(18, 38, 32, 0.24);
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.document-meta div { border-bottom: 1px solid var(--line); padding: 1rem; text-align: left; }
.document-meta div:nth-child(odd) { border-right: 1px solid var(--line); }
.document-meta div:nth-last-child(-n + 2) { border-bottom: 0; }
.document-meta span { color: rgba(18, 38, 32, 0.48); display: block; font-size: 0.6rem; letter-spacing: 0.12em; }
.document-meta strong { color: var(--ink); display: block; font-family: Menlo, Monaco, Consolas, monospace; font-size: 0.8rem; font-weight: 500; margin-top: 0.55rem; }
.document-meta .active-status { color: #9a622c; }
.content { padding: 0; }
.document-layout { display: grid; padding-left: 0; padding-right: 0; }
.document-index { display: none; }
.document-body { min-width: 0; }
.document-section {
  border-bottom: 1px solid var(--line);
  display: grid;
  gap: 1.25rem;
  grid-template-columns: 2rem minmax(0, 1fr);
  padding: 3.5rem 1.25rem;
  scroll-margin-top: 5rem;
}
.section-number {
  color: var(--accent);
  font-family: Georgia, "Times New Roman", serif;
  font-size: 0.82rem;
  padding-top: 0.5rem;
}
.document-section h2 {
  color: var(--ink);
  font-family: Georgia, "Times New Roman", serif;
  font-size: 2rem;
  font-weight: 400;
  line-height: 1.2;
  margin: 0 0 1.5rem;
  text-align: left;
}
.document-section p,
.document-section li {
  color: rgba(18, 38, 32, 0.67);
  font-size: 0.9rem;
  line-height: 1.85;
  margin: 0;
  text-align: left;
}
.document-section p + p { margin-top: 1rem; }
.numbered-list,
.boundary-list,
.security-list { list-style: none; margin: 0; padding: 0; }
.numbered-list { border-top: 1px solid var(--line); }
.numbered-list li {
  border-bottom: 1px solid var(--line);
  display: grid;
  gap: 1rem;
  grid-template-columns: 2rem 1fr;
  padding: 1rem 0;
}
.numbered-list span { color: #9a622c; font-family: Georgia, "Times New Roman", serif; font-size: 0.74rem; }
.dark-section { background: var(--ink); color: #f7f3e8; }
.dark-section h2 { color: #f7f3e8; }
.dark-section .section-number { color: #e6a15d; }
.boundary-list { border-top: 1px solid rgba(247, 243, 232, 0.18); }
.boundary-list li { border-bottom: 1px solid rgba(247, 243, 232, 0.18); color: rgba(247, 243, 232, 0.7); padding: 1rem 0 1rem 1.25rem; position: relative; }
.boundary-list li::before { background: #e6a15d; content: ""; height: 5px; left: 0; position: absolute; top: 1.75rem; width: 5px; }
.security-list { display: grid; gap: 1rem; }
.security-list li { border-left: 2px solid var(--accent); padding-left: 1rem; }
.notice {
  background: #d9d3c5;
  border-bottom: 1px solid var(--line);
  padding: 3.5rem 1.25rem;
  text-align: left;
}
.notice-kicker { color: #8d592c; font-size: 0.68rem; font-weight: 700; letter-spacing: 0.14em; margin: 0 0 1.25rem; text-transform: uppercase; }
.notice strong { color: var(--ink); display: block; font-family: Georgia, "Times New Roman", serif; font-size: 1.75rem; font-weight: 400; }
.notice > p:last-child { color: rgba(18, 38, 32, 0.68); font-size: 0.92rem; line-height: 1.8; margin: 1rem 0 0; }
.actions {
  display: grid;
  padding: 1.5rem 1.25rem 5rem;
}
.action-link {
  align-items: center;
  border-bottom: 1px solid var(--line);
  color: var(--ink);
  display: flex;
  font-size: 0.82rem;
  justify-content: space-between;
  padding: 1rem 0;
  text-decoration: none;
}
.action-link.primary {
  background: var(--ink);
  color: #f7f3e8;
  margin-top: 1rem;
  padding: 1rem;
}
@media (min-width: 1024px) {
  .hero { padding: 7rem 0 6rem; }
  .hero-grid { align-items: end; grid-template-columns: 1.45fr 0.55fr; gap: 6rem; }
  h1 { font-size: 4rem; }
  .document-layout { grid-template-columns: 300px minmax(0, 1fr); }
  .document-index {
    align-self: start;
    border-right: 1px solid var(--line);
    display: flex;
    flex-direction: column;
    padding: 5rem 2.5rem 0 1.25rem;
    position: sticky;
    top: 4rem;
  }
  .index-label { color: rgba(18, 38, 32, 0.42); font-size: 0.68rem; letter-spacing: 0.14em; margin: 0 0 1.5rem; text-align: left; text-transform: uppercase; }
  .document-index a { border-top: 1px solid var(--line); color: rgba(18, 38, 32, 0.68); display: grid; font-size: 0.76rem; gap: 0.8rem; grid-template-columns: 1.5rem 1fr; line-height: 1.5; padding: 1rem 0; text-align: left; text-decoration: none; }
  .document-index a span { color: var(--accent); font-family: Georgia, "Times New Roman", serif; }
  .document-section { gap: 2.5rem; grid-template-columns: 3rem minmax(0, 1fr); padding: 5rem 4rem; }
  .document-section h2 { font-size: 2.7rem; }
  .notice { padding: 5rem 4rem; }
  .notice strong { font-size: 2.35rem; }
  .actions { grid-template-columns: repeat(3, minmax(0, 1fr)); padding: 2rem 4rem 6rem; }
  .action-link { border-right: 1px solid var(--line); padding: 1.2rem; }
  .action-link.primary { margin-top: 0; }
}
@media (max-width: 560px) {
  .hero { padding: 4rem 0; }
  h1 { font-size: 2.35rem; }
  .document-section h2 { font-size: 1.8rem; }
  .document-meta strong { overflow-wrap: anywhere; }
}
</style>
